const icons = {
  "you-tube": "61697",
  "world-cruise-collection": "61698",
  "wine-sailings": "61699",
  "wheelchair": "61700",
  "warning": "61701",
  "voyages": "61702",
  "verified_user": "61703",
  "venetian-society-saving": "61704",
  "user": "61705",
  "user-booking": "61706",
  "twitter": "61707",
  "training": "61708",
  "threads": "61709",
  "suites": "61710",
  "suite-upgrade-promo": "61711",
  "suite-upgrade-discount": "61712",
  "star": "61713",
  "special-price": "61714",
  "single-fares": "61715",
  "shore-excursions": "61716",
  "ship": "61717",
  "ship-lateral": "61718",
  "ship-lateral-stroke": "61719",
  "services": "61720",
  "secure-payment": "61721",
  "secure-payment-card": "61722",
  "search": "61723",
  "routes": "61724",
  "routes-2": "61725",
  "reduced-fares-in-business-class": "61726",
  "quito-by-night": "61727",
  "public-area": "61728",
  "promo": "61729",
  "privato": "61730",
  "private-flight-in-business-class": "61731",
  "pre-cruise": "61732",
  "post-cruise": "61733",
  "ports": "61734",
  "plus": "61735",
  "play": "61736",
  "placeholder": "61737",
  "pinterest": "61738",
  "pin": "61739",
  "phone": "61740",
  "pdf": "61741",
  "payment": "61742",
  "pack": "61743",
  "pack-denali": "61744",
  "p2p-prepaid-promo": "61745",
  "p2p-prepaid-discount": "61746",
  "open-tab": "61747",
  "new": "61748",
  "my-services": "61749",
  "minus": "61750",
  "meal-included": "61751",
  "logo": "61752",
  "limited": "61753",
  "limited-space-available": "61754",
  "instagram": "61755",
  "info": "61756",
  "hotel-charter": "61757",
  "gentlemen-host": "61758",
  "generic-promo-square": "61759",
  "generic-promo-horizontal": "61760",
  "free-transfers": "61761",
  "free-hotel": "61762",
  "free-flight": "61763",
  "food-beverage": "61764",
  "flight": "61765",
  "flight-right": "61766",
  "flight-info": "61767",
  "flag": "61768",
  "filters": "61769",
  "facebook": "61770",
  "expand": "61771",
  "evening-excursions": "61772",
  "email": "61773",
  "economy-class-flight": "61774",
  "early-booking-bonus": "61775",
  "duration_2-h": "61776",
  "duration": "61777",
  "duration-all-day": "61778",
  "duration-8-h": "61779",
  "duration-4-h": "61780",
  "download": "61781",
  "door-to-door": "61782",
  "discount-chip": "61783",
  "dining": "61784",
  "diamond": "61785",
  "days": "61786",
  "culinary-sailings": "61787",
  "countries": "61788",
  "connecting-suite": "61789",
  "compass": "61790",
  "communication": "61791",
  "close": "61792",
  "clock": "61793",
  "circle": "61794",
  "circle-question": "61795",
  "circle-phone": "61796",
  "circle-close": "61797",
  "circle-check": "61798",
  "chevron-up": "61799",
  "chevron-right": "61800",
  "chevron-left": "61801",
  "chevron-down": "61802",
  "check": "61803",
  "chat": "61804",
  "cancellation": "61805",
  "business-class-flight": "61806",
  "bullet": "61807",
  "brochure": "61808",
  "bridge-sailings": "61809",
  "bath-shower-separate": "61810",
  "bath-shower-combination": "61811",
  "authentic-experience": "61812",
  "arrow-up": "61813",
  "arrow-right": "61814",
  "arrow-left": "61815",
  "arrow-down": "61816",
  "antarctica-bridge": "61817",
  "anchor": "61818",
  "all-inclusive-offer": "61819",
  "alert": "61820",
  "alarm": "61821",
  "alarm-clock": "61822",
  "activity-level-full": "61823",
  "activity-level-empty": "61824",
  "accessibility": "61825",
  "3rd-guest-capacity": "61826"
};
export default icons;